// extracted by mini-css-extract-plugin
export var ArticleContainer = "BlockLrSearchResult-module--ArticleContainer--4dec6";
export var ArticleContainerReverse = "BlockLrSearchResult-module--ArticleContainerReverse--2b71a";
export var articleContent = "BlockLrSearchResult-module--articleContent--c5593";
export var articleImage = "BlockLrSearchResult-module--articleImage--a7198";
export var capitalize = "BlockLrSearchResult-module--capitalize--97376";
export var date = "BlockLrSearchResult-module--date--be0ae";
export var desciptionHover = "BlockLrSearchResult-module--desciptionHover--b4488";
export var fs14 = "BlockLrSearchResult-module--fs-14--6a21a";
export var fs16 = "BlockLrSearchResult-module--fs-16--7c043";
export var fs20 = "BlockLrSearchResult-module--fs-20--21268";
export var fs24 = "BlockLrSearchResult-module--fs-24--18da6";
export var fs32 = "BlockLrSearchResult-module--fs-32--1dad4";
export var fs40 = "BlockLrSearchResult-module--fs-40--ec3cd";
export var fsItalic = "BlockLrSearchResult-module--fs-italic--c61ba";
export var fsLg = "BlockLrSearchResult-module--fs-lg--d850e";
export var fsMd = "BlockLrSearchResult-module--fs-md--23e11";
export var fsNormal = "BlockLrSearchResult-module--fs-normal--99bb1";
export var fsSm = "BlockLrSearchResult-module--fs-sm--7d1ef";
export var fsXl = "BlockLrSearchResult-module--fs-xl--b9f30";
export var fsXs = "BlockLrSearchResult-module--fs-xs--ae81a";
export var fsXxl = "BlockLrSearchResult-module--fs-xxl--9eedc";
export var fsXxs = "BlockLrSearchResult-module--fs-xxs--92cb0";
export var fwBold = "BlockLrSearchResult-module--fw-bold--b7a15";
export var fwMedium = "BlockLrSearchResult-module--fw-medium--d1c66";
export var fwNormal = "BlockLrSearchResult-module--fw-normal--7a8de";
export var gotham_bold = "BlockLrSearchResult-module--gotham_bold--eeafe";
export var gotham_bold_italic = "BlockLrSearchResult-module--gotham_bold_italic--a1652";
export var gotham_book = "BlockLrSearchResult-module--gotham_book--bcc56";
export var gotham_book_italic = "BlockLrSearchResult-module--gotham_book_italic--76fed";
export var icon = "BlockLrSearchResult-module--icon--3e8a2";
export var iconContainer = "BlockLrSearchResult-module--iconContainer--89fe4";
export var lowercase = "BlockLrSearchResult-module--lowercase--a46bb";
export var tags = "BlockLrSearchResult-module--tags--1680e";
export var tagsContainer = "BlockLrSearchResult-module--tagsContainer--ddf86";
export var tagsSwiper = "BlockLrSearchResult-module--tagsSwiper--56e97";
export var title = "BlockLrSearchResult-module--title--2e713";
export var uppercase = "BlockLrSearchResult-module--uppercase--6e1db";